import { navigate } from 'gatsby';
import React from 'react';

/**
 *
 * @param {object} props
 * @param {string} props.to The internal URL to redirect to.
 * @param {boolean} [props.replace] Should it replace the previous URL or still be navigable via the back button?
 * @returns
 */
export default function Redirect({ to, ...rest }) {
  React.useEffect(() => {
    navigate(to, rest);
  });
  return null;
}
